import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import ARRAY from "../../../UTIL/ARRAY";
import { number, string } from "yargs";
import GameInstance from "../GameInstance";
 
class GameAnalytics
{
    private conquer         : CONQUER;
    public tabs             : any;
    private vars            : any = {};
    public data             : any = {};
    private interval        : any;
    private dirty           : any = [];
    private gameInstance    : GameInstance;
    private isFirstClick    : boolean = true;
 
    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
        this.vars           = { gameID:gameInstance.gameID };

        let self            = this;
        let vars            = this.vars;

        let conquer         = this.conquer;

        this.interval = setInterval( function()
        {
            if( !self.dirty.length ) return;
 
            conquer.do( ACTIONS.ANALYTICS_SET, ARRAY.extract( vars, { $vars:self.dirty }) );
 
            self.dirty  = [];

        }, 16.66 );
 
        if ( typeof window != 'undefined' ) window.onerror = function( event:any, source?:any, lineno?:any, colno?:any, error?:any )
        {
            conquer.do( ACTIONS.ANALYTICS_SET, ARRAY.extract( vars, { label:"onJSError", value:event, source:source, lineno:lineno, colno:colno, error:error } ));
        }

        this.onGame();
    }

    /*================


    SET


    =================*/

    public set( label:string, value?:any )
    {
        this.dirty.push({ label:label, value:value });
    }
 
    public setPayload( object:any )
    {
        this.vars = object;
    }
 
    /*================


    BUG REPORTING


    =================*/

    public onError( value?:any )
    {
        this.set( "onError", value );
    }

    /*================


    STARTUP


    =================*/
 
    public onPreloadEnd( value?:any )
    {
        this.set( "onPreloadEnd", value );
    }

    /*================


    INTERFACE


    =================*/

    public onUI( value?:any )
    {
        this.set( "onUI", value );
    }

    public onUIOut( value?:any )
    {
        this.set( "onUIOut", value );
    }

    public onButton( value?:any )
    {
        if( !value || value === "Button" ) return;

        if( this.isFirstClick ) this.set( "onFirstClick", value );
        this.isFirstClick = false;

        this.set( "onButton", value );
    }

 
    /*================


    TUTORIAL


    =================*/
 
    public onTutorialStart( value?:any )
    {
        this.set( "onTutorialStart", value );
    }

    public onTutorialStage( value?:any )
    {
        this.set( "onTutorialStage", value );
    }

    public onTutorialComplete( value?:any )
    {
        this.set( "onTutorialComplete", value );
    }
 
    /*================


    ADS


    =================*/

    public noAds( value?:any )
    {
        this.set( "noAds", value );
    }

    public onAdRequest( value?:any )
    {
        this.set( "onAdRequest", value );
    }
 
    public onAdComplete( value?:any )
    {
        this.set( "onAdComplete", value );
    }

    public onAdError( value?:any )
    {
        this.set( "onAdError", value );
    }

    /*================


    SHOP


    =================*/

    public onShopEnter( value?:any )
    {
        this.set( "onShopEnter", value );
    }

    public onShopExit( value?:any )
    {
        this.set( "onShopExit", value );
    }
 
    public onPurchase( value?:any )
    {
        this.set( "onPurchase", value );
    }


    /*================


    GAME


    =================*/

    public onGame()
    {
        this.set( "onGame" );
    }
 
    public onPlay( boolean:boolean )
    {
        this.set( "onPlay" );
        if( boolean ) this.set( "onPlayRewarded" );
    }
 
    public onGameReady()
    {
        this.set( "onGameReady" );
    }
 
    public onGameStart()
    {
        this.set( "onGameStart" );
    }

    public onDie( value?:any )
    {
        this.set( "onDie", value );
    }

    public onTimeUp( value?:any )
    {
        this.set( "onTimeUp", value );
    }
    
    public onContinue( value?:any )
    {
        this.set( "onContinue", value );
    }

    public onGameOver( value?:any )
    {
        this.set( "onGameOver", value );
    }
 
    public onGameExit( value?:any )
    {
        this.set( "onGameExit", value );
    }

 
    /*================


    MATCH


    =================*/
 
    public onMatchEnd( value?:any )
    {
        this.set( "onMatchEnd", value );
    }

    /*================


    SCOREBOARD


    =================*/

    public onCollectScoreboard( value?:any )
    {
        this.set( "onCollectScoreboard", value );
    }


}

export default GameAnalytics;